module.exports = __webpack_public_path__ + "img/bonus_phone_th.6510b2ea.png";